import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const NewYeargifts = () => {
  const CTAContent = [
    {
      pageName: "New Year Gifts",
      paragraphitalic: "Start the Year with a Bang! ",
      paragraphText:
        "Welcome the new beginnings with gifts that inspire excitement and set the tone for the year ahead. From elegant planners to premium hampers, our curated New Year gifts will leave a lasting impact on your clients and employees alike.",
      ContactFormName: "New Year Gifts",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Custom Calendars & Diaries",
      parapgraphItalic: "Mark the Date in Style!",
      sectionparagraphText: (
        <>
          <p>
            Elevate everyday planning with calendars and diaries designed just for you. 
          </p>
          <p>
            Who says calendars and diaries need to be boring? At eYantra, we turn everyday essentials into extraordinary keepsakes. Whether it’s a sleek minimalist design or a vibrant splash of colours, our custom calendars and diaries help you make every date special. 
          </p>
        </>
      ),
      ImgSrc: "../assests/images/new-year/Custom Calendars & Diaries.jpg",
      
    },

    /**Catagory Img */
    {
      index: 1,
      sectionName: "Luxurious Gift Boxes",
      parapgraphItalic: "Unbox Luxury, Every Time",
      sectionparagraphText: (
        <>
          <p>
            Redefine gifting with hampers that are as exquisite as they are memorable.
          </p>
          <p>
            Step into the world of luxury gifting with eYantra’s premium hampers. Overflowing with indulgent treats and curated treasures, our gift boxes are designed to create jaw-dropping unboxing moments. Whether it’s for your top-tier clients or a special team celebration, these hampers redefine opulence. 
          </p>
        </>
      ),
      ImgSrc: "../assests/images/new-year/Luxurious Gift Boxes.jpg",
      categoryHeadingLeftSide: "Features to Indulge In",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/new-year/Premium Selections.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Premium Selections</b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/new-year/Customizable Hampers.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Customizable Hampers</b> <br></br>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/new-year/Stunning Packaging.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Stunning Packaging</b> <br></br>
              </p>
            </>
          ),
        },
      ],
    },
  ];
  const noGapContent = [
    {
      RightImgNogap: "../assests/images/new-year/Features That Wow.jpg",
      NogapHeading: "Features That Wow",
      Heading: [
        {
          ListHeading: "Personalized Perfection",
          ListParagraph:
            "Add your logo, brand colours, or a motivational quote for a personal touch.",
        },
        {
          ListHeading: "Creative Layouts",
          ListParagraph:
            "Choose from unique formats—wall calendars, desk flip stands, or even digital hybrids!",
        },
        {
          ListHeading: "High-Quality Finish",
          ListParagraph:
            "From silky smooth pages to durable covers, every detail speaks luxury",
        },
      ],
    },
    {
      RightImgNogap: "../assests/images/new-year/Personalized Desk Essentials.jpg",
      NogapHeading: "Personalized Desk Essentials",
      paragraphItalic: "Desk Goals, Delivered!",
      paragraphDetail: (
        <>
          <p>
            Turn workspaces into wonderlands with desk essentials that blend functionality and flair.     
          </p>
          <p>
            Why settle for mundane when you can upgrade to magnificent? Our personalized desk essentials bring a touch of creativity and sophistication to every workspace. Perfect for sparking productivity or simply making someone smile every Monday morning! 
          </p>
        </>
      ),

      NogapSubheading: "Features That Shine",
      Categories: [
        {
          ServiceImg: "../assests/images/new-year/Name It, Own It.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Name It, Own It</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/new-year/Innovative Products.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Innovative Products</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/new-year/Elegant Aesthetics.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Elegant Aesthetics</b>
              </p>
            </>
          ),
        },
      ],
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
      NogapHeading: "Milestone Recognition ",
      paragraphItalic: "Make sure every gift reflects excellence.",
      paragraphDetail: (
        <>
          <p>Appreciate dedication and achievements.</p>
          <p>
            Show appreciation for the hard work and dedication that goes into
            every achievement.
          </p>
          <p>
            Milestones such as work anniversaries, project completions, and
            promotions deserve to be celebrated. At eYantra, we provide a range
            of premium milestone gifts that are as unique as the achievements.
          </p>
        </>
      ),

      NogapSubheading: "Our Milestone Gift Options Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Personalized Awards</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Luxury Gift Hampers</b>
              </p>
            </>
          ),
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: (
            <>
              <p className="fs-14">
                <b>Luxury Gift Hampers</b>
              </p>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          New Year Gifts
        </title>
        </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let your gifts carry the message of growth, optimism, and gratitude as you start the year anew. 
      </p>
    </>
  );
};

export default NewYeargifts;
